module.exports = __webpack_public_path__ + "static/logo-header-f5ae285c2aa7d973fd03cbd5320b8012.svg";